import HttpService from './http.service';

class WarehouseService {
  getWarehouses(params) {
    return HttpService.get('warehouses', {
      params,
    })
      .then((res) => res.data);
  }

  getStocks(params) {
    return HttpService.get('warehouses/stocks', {
      params,
    })
      .then((res) => res.data);
  }

  exportToXlSX(params) {
    return HttpService.post('warehouses/stocks_to_excel', {
      params,
    })
      .then((res) => res.data);
  }

  suggestWarehouses(params) {
    return HttpService.get('warehouses/suggestions', { params })
      .then((res) => res.data);
  }

  getWarehouse(id) {
    return HttpService.get(`warehouses/${id}`)
      .then((res) => res.data);
  }

  createWarehouse(warehouse) {
    return HttpService.post('warehouses', warehouse)
      .then((res) => res.data);
  }

  updateWarehouse(warehouse) {
    return HttpService.patch(`warehouses/${warehouse.id}`, warehouse)
      .then((res) => res.data);
  }

  deleteWarehouse(warehouse) {
    return HttpService.delete(`warehouses/${warehouse.id}`)
      .then((res) => res.data);
  }
}

export default new WarehouseService();
